import { type FC } from 'react';
import { Switch } from '@headlessui/react';
import clsx from 'clsx';

interface SwitchButtonProps {
  label?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (e: boolean) => void | Promise<void>;
  width?: number;
  height?: number;
  size?: 'small' | 'medium';
}

const SwitchButton: FC<SwitchButtonProps> = ({
  label,
  checked,
  defaultChecked,
  onChange,
  size = 'medium',
}) => {
  const isSmall = size === 'small';
  const isMedium = size === 'medium';
  return (
    <div className="flex items-center gap-4">
      <Switch
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={onChange}
        className={clsx(
          `data-[checked]:bg-tertiary-dark bg-gray-40 relative inline-flex shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`,
          isSmall && 'h-[16px] w-[28px]',
          isMedium && 'h-[20px] w-[37px]'
        )}
      >
        {({ checked }) => (
          <span
            aria-hidden="true"
            className={clsx(
              'pointer-events-none inline-block transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out',
              checked && isSmall ? 'translate-x-3' : 'translate-x-0',
              checked && isMedium ? 'translate-x-4' : 'translate-x-0',
              isSmall && 'h-[12px] w-[12px]',
              isMedium && 'h-[16px] w-[17px]'
            )}
          />
        )}
      </Switch>
      <label className="text-base">{label}</label>
    </div>
  );
};
export default SwitchButton;
